/* One shared track per content role keeps mixed-width cards aligned without truncating text. */
if(!customElements.get('ss-card-grid'))customElements.define('ss-card-grid',class extends HTMLElement{
  connectedCallback(){
    if(!document.body.classList.contains('ss-home-cards'))return;
    this.observer?.disconnect();
    this.schedule=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.align());};
    this.observer=new ResizeObserver(this.schedule);
    this.observer.observe(this);
    this.querySelectorAll('.ss-gallery-card__title,.ss-gallery-card__copy,.ss-price,.ss-gallery-card__vendor,.ss-gallery-card__action').forEach(e=>this.observer.observe(e));
    document.fonts.ready.then(()=>{if(this.isConnected)this.schedule();});
    this.schedule();
  }
  disconnectedCallback(){this.observer?.disconnect();cancelAnimationFrame(this.frame);}
  align(){
    if(innerWidth<1100||!CSS.supports('grid-template-rows','subgrid')){this.style.gridTemplateRows='';this.removeAttribute('data-aligned');return;}
    const width=this.getBoundingClientRect().width;if(!width)return;
    const gap=parseFloat(getComputedStyle(this).columnGap)||24;
    const square=(width-4*gap)/5*2+gap;
    const roles=['.ss-gallery-card__title','.ss-gallery-card__copy','.ss-price','.ss-gallery-card__vendor','.ss-gallery-card__action'];
    const cards=[...this.children],tracks=[];
    for(let i=0;i<cards.length;i+=4){
      const row=cards.slice(i,i+4);
      const sizes=roles.map(selector=>Math.max(0,...row.map(card=>card.querySelector(selector)?.getBoundingClientRect().height||0)));
      let text=sizes.reduce((sum,n)=>sum+n,0);
      const height=Math.max(square,text+180);
      const spare=Math.max(0,height/2-text);sizes[1]+=spare;text+=spare;
      tracks.push(height-text,...sizes.slice(0,-1),sizes.at(-1)+24);
    }
    const value=tracks.map(n=>n.toFixed(3)+'px').join(' ');
    if(this.style.gridTemplateRows!==value)this.style.gridTemplateRows=value;
    this.setAttribute('data-aligned','');
  }
});
